import { useSelectRootContext } from '../root/SelectRootContext';
import { useSelectTriggerContext } from '../trigger/SelectTrigger';
import { useSelectValueNode } from '../value/useSelectValueNode';

export const useSelectPlaceholderVisible = () => {
    const { mode, autoComplete, isInlineInputSearchVisible, value, internalSearchValue } =
        useSelectRootContext();
    const selectedValueNode = useSelectValueNode();
    const { hasCustomInput } = useSelectTriggerContext();

    if (hasCustomInput) return false;

    if (mode === 'multiple') return true;

    // Hide placeholder if there's search input
    if (isInlineInputSearchVisible && internalSearchValue) {
        return false;
    }

    // Show placeholder for autocomplete without value
    if (autoComplete && (value === undefined || value === null || value === '')) {
        return true;
    }

    // Show placeholder for inline search without value and no search input
    if (
        isInlineInputSearchVisible &&
        (value === undefined || value === null || value === '') &&
        !internalSearchValue
    ) {
        return true;
    }

    return !selectedValueNode;
};
